/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLenis } from "./SmoothScroll";
const TermsOfUse = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  return (

    <>
    
   <title>Terms of Use | Citrus Diagnostic Center Crystal River,Florida</title>
    <meta name="description" content="The Terms of Use at Citrus Diagnostic Center, Crystal River, define service standards, website access rules, and responsibilities for a secure user experience." />
    <div className="flex justify-center items-center pt-48 lg:pt-[14.0625rem]">
      <div className="w-4/5  flex flex-col items-center  pb-8 lg:pb-16">
        <h1
       
          className="text-[#d78558] font-robout lg:text-6xl md:text-5xl text-4xl lg:pb-20 capitalize text-center  leading-tight sm:leading-snug font-black"
        >
          Terms of Use
        </h1>
        <div className="text-left">
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 py-8 text-left font-robout">
            Effective Date: September 7, 2025
          </p>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 py-8 text-left font-robout">
            Welcome to the website of{" "}
            <span className="text-[#ffffff]">Citrus Diagnostic Center </span>{" "}
            (“Company,” “we,” “our,” or “us”). By accessing or using our
            website, you agree to these Terms of Use. If you do not agree,
            please do not use our website.
          </p>
          <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 py-10">
            1. Informational Purposes Only
          </h2>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
            The content on this website is provided for general informational
            purposes. It is not medical advice and should not be relied on as a
            substitute for consultation with qualified healthcare professionals.
          </p>
          <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 py-10">
            2. No Provider–Patient Relationship
          </h2>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
            Your use of this website does not create a provider–patient
            relationship between you and Citrus Diagnostic Center. For medical
            advice, diagnosis, or treatment, please schedule an appointment with
            one of our licensed providers.
          </p>
          <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 py-10">
            3. Intellectual Property
          </h2>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
            All text, graphics, logos, designs, and other content on this
            website are the property of Citrus Diagnostic Center or licensed to
            us. You may not copy, reproduce, distribute, or use our content
            without prior written permission.
          </p>
          <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 py-10">
            4. Acceptable Use
          </h2>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
            You agree not to use this website in any unlawful manner or in a way
            that could damage or impair the site. Misuse, including attempts to
            hack or disrupt our systems, is strictly prohibited.
          </p>
          <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 py-10">
           5. Third-Party Links
          </h2>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
           Our website may contain links to third-party websites. We are not responsible for the content, security, or privacy practices of those sites.
          </p>
          <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 py-10">
           6. Limitation of Liability
          </h2>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
            Citrus Diagnostic Center is not liable for any damages resulting from your use of, or inability to use, this website.
          </p>
          <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 py-10">
           7. Governing Law
          </h2>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
           These Terms of Use are governed by the laws of the State of Florida, without regard to conflicts of law principles.
          </p>
          <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 py-10">
           8. Changes
          </h2>
          <p className="xl:text-[1.33rem] md:text-lg text-lg text-white lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
            We may update these Terms of Use at any time. Continued use of our website after updates means you accept the revised terms.
          </p>
           <h2 className="xl:text-[1.8rem] text-2xl text-[#d78558] font-bold lg:ps-0 md:px-8 px-4 pb-4">
          9. Contact Us
          </h2>
          <h3 className="xl:text-[1.33rem] md:text-lg text-lg text-white py-10">
            If you have questions about these Terms of Use, please contact us:
          </h3>
          <ul className="xl:text-[1.33rem]  md:text-lg text-lg flex flex-col gap-3 text-white px-8 pb-8  text-left font-robout">
            <li>
              <span className="text-[#d78558]">Phone : </span>{" "}
              <a href="tel:3527959200"> (352) 450-8062</a>
            </li>
            <li>
              <span className="text-[#d78558]">Email : </span>{" "}
              <a href="mailto:info@citrusdiagnosticcenter.com">
                info@citrusdiagnosticcenter.com
              </a>
            </li>
            <li>
              <span className="text-[#d78558]">Address : </span>{" "}
              <a href="https://share.google/yVmeZoTlzXqwnAFvJ">
               922 N Citrus Ave, Crystal River, FL 34428
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
      </>
  );
};

export default TermsOfUse;
